import * as tslib_1 from "tslib";
import store from '../store/store';
import { setBit } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { updateUserConfiguration } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    viewStateConfiguration: function () { return getUserConfiguration().ViewStateConfiguration; },
})(action('saveDateHeadersOption')(function saveDateHeadersOption(isEnabled, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, viewStateConfiguration, isDateHeadersEnabled;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, viewStateConfiguration = state.viewStateConfiguration;
                    isDateHeadersEnabled = isEnabled === void 0 ? optionState.isEnabled : isEnabled;
                    setBit(!isDateHeadersEnabled, 2 /* DateHeadersDisabled */);
                    return [4 /*yield*/, updateUserConfiguration([
                            {
                                propertyName: 'ListViewBitFlags',
                                propertyType: 'Integer32',
                                propertyValue: "" + viewStateConfiguration.ListViewBitFlags,
                            },
                        ], 'OWA.ViewStateConfiguration')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveDateHeadersOption.js.map